import { ResourceCentrePageCategoryItem } from '../../../types';

export const translations: ResourceCentrePageCategoryItem = {
  title: 'Social Insurance Number',
  content: [
    'If your SIN is lost or stolen, the government will not issue a new SIN or a new SIN card.',

    '<ul>',
    '<li>The only way to receive a new number is if you are able to prove your SIN is being used fraudulently.</li>',
    '<li>Plastic SIN cards have been replaced with paper "confirmation of SIN" letters.</li>',
    '</ul>',

    'It is important to follow these steps in the case of a lost or stolen SIN:',
    '<ul>',
    '<li><strong>Visit a Service Canada Centre immediately</strong><br />',
    'Report your lost or stolen SIN to a Service Canada location and request to receive a SIN confirmation letter',
    'for free. Complete the Personal Information Request form and indicate on the form that you are requesting',
    'copies of previously submitted SIN application form(s) under the Privacy Act, Bank ESDC PPU 390. You will need',
    'to provide an original Birth certificate, Canadian citizenship certificate, certificate of registration of',
    'birth abroad or permanent resident card. In some situations, you may also need to provide proof of a change',
    'of name, adoption order, certificate of marriage or other documents. Full details on the required identity',
    'documents can be found here.</li>',

    '<li><strong>Monitor for suspicious activity</strong><br />',
    'Monitor your bank statements, credit/debit card statements and credit reports for suspicious activity and',
    'report any breaches that may have occurred to the police and to the financial institution. OnGuard',
    'subscribers have access to online monitoring to alert you if your registered SIN is found online.</li>',
    '</ul>'
  ].join('\n')
};
